export enum TarFileType {
  /** '\0' or '0' */
  File = 0,
  /** '5' */
  Dir = 48 + 5,
  /** 'L' GNU tar extension for @LongLink */
  GnuLongName = 76,
}

// GNU tar constants
export const GNU_MAGIC = 'ustar  ';
export const GNU_LONGNAME_TYPE = 'L';
export const MAX_FILENAME_LENGTH = 100;
export const GNU_LONGNAME_HEADER = '././@LongLink';
